// axios
import axios from 'axios'

let temp;
if (process.env.NODE_ENV == "development") {
  temp = process.env.VUE_APP_API_BASE_DEVELOPMENT_URL;
} else {
  temp = process.env.VUE_APP_API_BASE_URL;
}

let endpointStorage = localStorage.getItem('endpoint');
if (endpointStorage != null && endpointStorage != '') {
  temp = endpointStorage;
}
let clientId = localStorage.getItem('domainId');
if (clientId == null) {
  clientId = '';
}

export const domain = temp;
export const client_id = clientId;

const instance = axios.create({
  baseURL: domain,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
    'G-ClientID': clientId,
  }
});

instance.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if(response.data && response.data.status !== 'OK' && response.data.message) {
    return Promise.reject(new Error(response.data.message.message || response.data.message));
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});
export default instance;
